const PATH_CONSULT_SOAT = "/constancia/electronica";
const PATH_PRINT_CONSULT_SOAT = `${PATH_CONSULT_SOAT}/imprimir`;
const PATH_SOAT_ONE_STEP = "/api-canal-soat-memory/datos/registrar";
const PATH_DIGITAL_ID = "/autenticacion-personas/cookies"

const endpoint = {
    PATH_CONSULT_SOAT,
    PATH_PRINT_CONSULT_SOAT,
    PATH_SOAT_ONE_STEP,
    PATH_DIGITAL_ID,
};

export default  endpoint;